module.exports = __webpack_public_path__ + "static/media/kakaoplus.0f03838b.svg";